import React from 'react';
import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import theme from 'Theme';
import PropTypes from 'prop-types';

const styles = (styleTheme) => ({
  root: {
    padding: styleTheme.spacing(2),
    borderRadius: styleTheme.radius.md,
  },
  showHover: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

const ShadedRoundBox = ({
  className,
  classes,
  children,
  color,
  onClick,
  test,
}) => {
  const boxClassNames = onClick
    ? classNames(className, classes.root, classes.showHover)
    : classNames(className, classes.root);
  return (
    <Box
      className={boxClassNames}
      style={{ backgroundColor: color }}
      onClick={onClick}
      test={test}
    >
      {children}
    </Box>
  );
};

ShadedRoundBox.defaultProps = {
  children: [],
  color: theme.palette.facet.lightGray5,
  className: null,
  onClick: null,
  test: 'shaded-round-box',
};

ShadedRoundBox.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.object,
  color: PropTypes.string,
  onClick: PropTypes.func,
  test: PropTypes.string,
};

export default withStyles(styles)(ShadedRoundBox);
